<template>
	<div class="classify_container content_width">
		<div class="left">
			<div class="title">
				<img :src="require('@/assets/home/classify_title_l_bg.png')">
				<div class="text">
					<svg class="icon_svg" aria-hidden="true">
						<use :xlink:href="sectionData.icon"></use>
					</svg>
					<span>{{ sectionData.title }}</span>
				</div>
			</div>
			<div class="images">
				<img :src="sectionData.image_url">
			</div>
		</div>
		<div class="right">
			<div class="title">
				<img :src="require('@/assets/home/classify_title_r_bg.png')">
				<div class="options">
					<div v-for="(sequence, sIndex) in groupedChildren" :key="sIndex" class="sequence"
						:class="sIndex < groupedChildren.length - 1 ? 'line' : ''">
						<div v-for="(child, cIndex) in sequence" :key="cIndex" class="item"
							:class="{'active': (child.slug || child.name) == rightClassActive}" @click="classifyChoose(child)">
							{{ child.name }}
						</div>
					</div>
				</div>
			</div>
			<div class="content">
				<div class="list_content">
					<div v-for="(item, index) in newsList" :key="item.id" class="list" @click="goArticle(item)">
						<div class="news">{{item.title}}</div>
						<div class="time font_size_12">{{item.time}}</div>
					</div>
				</div>
				<div class="images">
					<img :src="rightImage">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ClassifyComponent',
		props: {
			sectionData: {
				type: Object,
				default: () => ({
					title: '',
					icon: '',
					image_url: '',
					children: [],
				}),
			},
		},
		data() {
			return {
				rightClassActive: null,
				rightImage: null,
				newsList: [],
			}
		},
		computed: {
			groupedChildren() {
				const children = this.sectionData.children || []
				const grouped = []
				for (let i = 0; i < children.length && i < 12; i += 2) {
					grouped.push(children.slice(i, i + 2))
				}
				return grouped
			},
		},
		async mounted() {
			if (this.sectionData.children && this.sectionData.children.length) {
				this.classifyChoose(this.sectionData.children[0])
			}
		},
		methods: {
			classifyChoose(child) {
				this.rightClassActive = child.slug || child.name
				this.rightImage = child.image_url || null
				// 从 child 关联的文章中取前8条
				if (child.articles && child.articles.length) {
					this.newsList = child.articles.slice(0, 8).map(a => ({
						title: a.title,
						time: (a.published_at || '').slice(5, 10) || '',
						id: a.id,
					}))
				} else {
					this.newsList = []
				}
			},
			// 点击文章跳转详情
			goArticle(item) {
				if (!item || !item.id) return
				this.$router.push({ path: '/article', query: { id: item.id } }).catch(() => {})
			},
		}
	}
</script>

<style scoped>
	.classify_container {
		margin: 20px auto;
		display: flex;
		justify-content: space-between;

		.left {
			width: 290px;

			.title {
				position: relative;
				height: 68px;

				img {
					width: 100%;
					height: 100%;
				}

				.text {
					position: absolute;
					font-size: 20px;
					color: #fff;
					display: flex;
					align-items: center;
					top: 0;
					width: 100%;
					height: 100%;
					padding-left: 30px;

					.icon_svg {
						margin-right: 5px;
						font-size: 16px;
					}
				}
			}

			.images {
				background-color: #fff;
				width: 100%;
				padding: 10px 0;
			}
		}

		.right {
			width: 895px;

			.title {
				position: relative;
				height: 68px;

				img {
					width: 100%;
					height: 100%;
				}

				.options {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					display: flex;
					align-items: center;
					padding: 5px 0;
					font-size: 13px;
					color: #fff;

					.sequence {
						padding: 0 15px;
						width: 16.6%;

						.item {
							text-align: center;
							padding: 3px 0;
							cursor: pointer;
							margin: 6px 0;
						}

						.active {
							color: #303030;
							background-color: #90C6F6;
						}

						.item:hover {
							color: #303030;
							background-color: #90C6F6;
						}
					}

					.line {
						background-image: url('@/assets/home/classify_title_r_line.png');
						background-repeat: no-repeat;
						background-position: right center;
					}
				}
			}

			.content {
				padding: 10px;
				font-size: 14px;
				display: flex;
				justify-content: space-between;
				background-color: #fff;

				.list_content {
					width: calc(100% - 350px);
					display: flex;
					flex-direction: column;
					justify-content: space-around;

					.list {
						cursor: pointer;
						display: flex;
						align-items: center;
						justify-content: space-between;

						&:hover {
							color: #cb160d;
						}

						.news {
							width: 75%;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							position: relative;
							padding-left: 5px;
						}

						.news::before {
							content: '';
							display: inline-block;
							width: 1px;
							height: 1px;
							background-color: #000;
							border-radius: 50%;
							margin-right: 15px;
							position: absolute;
							top: 50%;
							left: 0;
							transform: translateY(-50%);

						}
					}
				}

				.images {
                    padding: 11px;
					>img {
						height: 240px;
					}
				}

			}
		}
	}
</style>